/* eslint-disable eqeqeq */
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import useMediaQuery from "@mui/material/useMediaQuery";
import moment from "moment";
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
// common_groupstructure_GETROW
import Grid from "@mui/material/Grid";
import WmsHead from "./processComponent/WmsHead";
import "./BinWiseCBMRreport.css";
import { CmpButton } from "../../Component/Common/ToolBox/ToolBox";
import GCWebReport from "../../Component/Common/ReuseableComponent/GCWebReport";

import { ReportRemoveSequenceChar, ReportUrl } from "../../Utility/Utilitys";

import {
  HeadObjectInit,
  sWebStockReportData,
  sWebStockReportArr,
  GetLocation,
  fValidationHead_Client,
  sWebBetweenReportArr,
} from "./BinWiseCBMRreportAction";

// import { set } from 'date-fns/esm';

export default function BinWiseCBMRreport() {
  const vMediaQuery = useMediaQuery("(max-width:450px)");

  //Head
  const [HeadObject, setHeadObject] = useState(HeadObjectInit);

  const [sLocationData, setLocationData] = useState([
    // { Uid: "Distribution", Value: "Distribution" },
  ]);

  //Head

  const fLocation = async (e) => {
    setHeadObject((obj) => ({
      ...obj,
      sLocation: e.target.value,
      sLocationArr: [],
      sLocationPrnt: "",
      sLocationName: "",
    }));
  };

  const fLocation_MultiSelect = async (value) => {
    let currentPrnt = value.map((option) => option.Cd).join(",");
    let currentName = value.map((option) => option.Name1).join(",");

    setHeadObject((obj) => ({
      ...obj,
      sLocationArr: value,
      sLocationPrnt: value?.length <= 0 ? "" : currentPrnt,
      sLocationName: value?.length <= 0 ? "" : currentName,
    }));
  };

  const fReportType = (e) => {
    setHeadObject((obj) => ({
      ...obj,
      sReportType: e.target.value,
    }));
  };
  const fCancel = (e) => {
    setHeadObject(HeadObjectInit);
  };

  const vRdxDBKernObj = useSelector((state) => state.SliceDB.value.DBKernObj);

  const GetReportsView = async () => {
    // let xReportTypeTitle =
    //   HeadObject.sReportType == "PENDING"
    //     ? "Pending"
    //     : "PROGRESS"
    //     ? "Progress"
    //     : "HISTORY"
    //     ? "History"
    //     : "Pending Detail";
    let xType = HeadObject.sReportType;

    let urlPrint = vRdxDBKernObj.WEB_REPORT_BASE_URL?.Val;
    let sCurrentReport = "";

    let ReportUrlObj = {
      trntyp: xType,
      loc: HeadObject.sLocationPrnt,
    };
    console.log(ReportUrlObj);
    sCurrentReport = ReportUrl(ReportUrlObj);

    sCurrentReport = ReportRemoveSequenceChar(sCurrentReport);
    console.log(
      "sCurrentReport",
      urlPrint + "WMS/BinWiseCBM?" + sCurrentReport
    );
    setWebReportUrlModal(urlPrint + "WMS/BinWiseCBM?" + sCurrentReport);
    fWebReport();
  };

  const fPreview = async (e) => {
    let iValidationHead_Client = fValidationHead_Client(HeadObject);
    if (!iValidationHead_Client) return;

    await GetReportsView();
  };

  //Modal fWebReportModal
  const [sWebReportModal, setWebReportModal] = useState(false);
  const [sWebReportUrlModal, setWebReportUrlModal] = useState("");
  const fWebReport = () => {
    setWebReportModal(true);
  };

  const fCloseWebReportModal = (e) => {
    setWebReportModal(false);
  };

  const fLoad = async () => {
    await GetLocation(setLocationData);
  };

  useEffect(() => {
    fLoad();
  }, []);

  return (
    <div className="container-fluid">
      <div className="row">
        <div></div>
        <div className="col-12">
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 0 }}
            columnSpacing={{ xs: 0, sm: 0, md: 0 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            className={vMediaQuery ? "py-4" : "py-4"}
          >
            <Grid item xs={12} sm={12} md={8}>
              <WmsHead
                fLocation_MultiSelect={fLocation_MultiSelect}
                sLocationData={sLocationData}
                sWebStockReportData={sWebStockReportData}
                sWebStockReportArr={sWebStockReportArr}
                HeadObject={HeadObject}
                fLocation={fLocation}
                fReportType={fReportType}
                sWebBetweenReportArr={sWebBetweenReportArr}
              />
            </Grid>
          </Grid>
          <Grid
            container
            rowSpacing={{ xs: 1, sm: 0, md: 0 }}
            columnSpacing={{ xs: 1, sm: 0, md: 3 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            className={
              vMediaQuery
                ? " justify-content-center text-center"
                : "py-2 justify-content-center text-center"
            }
          >
            <Grid item xs={6} sm={6} md={"auto"} className="text-center">
              <CmpButton
                xbtnName="Preview"
                xOnClick={fPreview}
                xVariant="contained"
                xDisabled={false}
                xSize="small"
                xId={""}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={"auto"} className="text-center">
              <CmpButton
                xbtnName="Cancel"
                xOnClick={fCancel}
                xVariant="contained"
                xDisabled={false}
                xSize="small"
                xId={""}
              />
            </Grid>
          </Grid>
        </div>
      </div>

      <GCWebReport
        xfCloseWebReportModal={fCloseWebReportModal}
        xWebReportUrlModal={sWebReportUrlModal}
        xTitle="Report"
        xWebReportModal={sWebReportModal}
      />
    </div>
  );
}
